import {
	SERVICE_DESK_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	toProjectType,
} from '@atlassian/jira-common-constants/src/project-types.tsx';

export type SupportedEotmProjectType =
	| typeof SERVICE_DESK_PROJECT
	| typeof PRODUCT_DISCOVERY_PROJECT;

const SUPPORTED_EOTM_PROJECT_TYPES: SupportedEotmProjectType[] = [
	SERVICE_DESK_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
];

export const isSupportedEotmProjectType = (
	value?: string | null,
): value is SupportedEotmProjectType => {
	const projectType = toProjectType(value);

	return (
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		!!projectType && SUPPORTED_EOTM_PROJECT_TYPES.includes(projectType as SupportedEotmProjectType)
	);
};
